// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__Form__1zIvX{display:grid;grid-template-columns:repeat(1, 1fr);row-gap:14px}.styles-module__LeftSide__29Ch2{padding-right:16px;row-gap:8px}.styles-module__Letter__2mgkW{height:80vh}", ""]);
// Exports
exports.locals = {
	"Form": "styles-module__Form__1zIvX",
	"LeftSide": "styles-module__LeftSide__29Ch2",
	"Letter": "styles-module__Letter__2mgkW"
};
export default exports;
